import { useEffect, useState } from 'react'
import { INotice } from '../../../types/notice'

export function Notice() {
    const [notices, setNotice] = useState<INotice[]>([])
    const [isMobile, setIsMobile] = useState<boolean | null>(null)

    useEffect(() => {
        const handleResize = () => {
            setIsMobile(window.innerWidth <= 768)
        }

        handleResize()
        window.addEventListener('resize', handleResize)
        return () => window.removeEventListener('resize', handleResize)
    }, [])

    useEffect(() => {
        if (isMobile === null) return

        const fetchNotices = async () => {
            // Backend endpoint para 'banner-fixo' não existe.
            // Para não gerar erros 500, a chamada foi desativada.
            // const periferico = isMobile ? 'mb' : 'pc'

            try {
                /* const response = await api.get<INotice[]>(
                    `${urls.Notices}?perifericos=${periferico}`
                )

                if (response.data && Array.isArray(response.data)) {
                    const filtered = response.data.filter(
                        (item) =>
                            item.notice_periferico?.toLowerCase().trim() ===
                            periferico.toLowerCase()
                    )
                    setNotice(filtered)
                } */
                setNotice([])
            } catch (error) {
                 // console.warn('Aviso: Não foi possível carregar os informativos (banner-fixo).', error)
            }
        }

        fetchNotices()
    }, [isMobile])

    if (notices.length === 0) return null

    return (
        <div className="w-full flex items-center justify-center mt-6 mb-4 lg:mt-6 lg:mb-6">
            <div className="w-11/12 lg:w-3/5">
                <a href={notices[0].link || '#'} target="_blank" rel="noreferrer" className="block">
                    <img
                        src={notices[0].nome_arquivo}
                        className="block w-full rounded-xl lg:rounded-lg shadow-premium dark:shadow-premium-dark dark:opacity-95 transition-opacity hover:opacity-90"
                        alt="Aviso importante"
                        loading="lazy"
                    />
                </a>
            </div>
        </div>
    )
}